<button nz-button nzSize="large" [nzBlock]="fullSize" (click)="open()">
  <i nz-icon nzType="radar-chart" nzTheme="outline"></i>
  <span *ngIf="fullSize">
    {{ 'AUCTION_SHEET_ZONES' | translate }}
  </span>
</button>
